var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "internal-page-main-section faq-section-main col-12" },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "survey-main-section col-12 float-l" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "btn btn-success form-group pull-right searchBtn sb-search-open faqSearch"
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchFAQ,
                          expression: "searchFAQ"
                        }
                      ],
                      staticClass: "form-control searchInput",
                      attrs: {
                        type: "text",
                        placeholder: "Search",
                        "aria-label": "Search"
                      },
                      domProps: { value: _vm.searchFAQ },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.searchFAQ = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "accordion float-l width-full",
                    attrs: { id: "accordionExample" }
                  },
                  [
                    _vm._l(_vm.questionList, function(questionAnswer, index) {
                      return [
                        _c("div", { staticClass: "card" }, [
                          _c(
                            "div",
                            {
                              staticClass: "card-header",
                              attrs: { id: "accordion" + questionAnswer.id }
                            },
                            [
                              _c("h5", { staticClass: "mb-0" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-link collapsed faqTitle",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "collapse",
                                      "data-target":
                                        "#" + "collapse" + questionAnswer.id,
                                      "aria-expanded": "false",
                                      "aria-controls":
                                        "collapse" + questionAnswer.id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                    " +
                                        _vm._s(questionAnswer.question) +
                                        "\n                                                "
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "collapse",
                              attrs: {
                                id: "collapse" + questionAnswer.id,
                                "aria-labelledby":
                                  "accordion" + questionAnswer.id,
                                "data-parent": "#accordionExample"
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "card-body faqBody",
                                domProps: {
                                  innerHTML: _vm._s(questionAnswer.answer)
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    })
                  ],
                  2
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [_vm._v(" FAQ\n\n                    ")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f44d9bd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f44d9bd4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ.vue
// module id = null
// module chunks = 